import React from 'react';
import { Outlet } from 'react-router';
import { Grid, GridColumn, GridRow, Layout } from '@axiom/ui';

import { EngagementsHistoryViewNavigation } from './EngagementsHistoryViewNavigation';

export type EngagementsHistoryViewProps = {
  name?: string;
};
export const EngagementsHistoryView: React.FC<EngagementsHistoryViewProps> = ({
  name = 'ENGAGEMENTS_HISTORY_VIEW',
}) => (
  <Grid name={name}>
    <GridRow>
      <GridColumn largeScreenWidth={4} smallScreenWidth={12}>
        <Layout verticalGutter="16px" direction="vertical">
          <EngagementsHistoryViewNavigation name="ENGAGEMENTS_HISTORY_VIEW_NAVIGATION" />
        </Layout>
      </GridColumn>
      <GridColumn largeScreenWidth={8} smallScreenWidth={12}>
        <Outlet />
      </GridColumn>
    </GridRow>
  </Grid>
);
